import { Trainee } from "src/redux/types/_trainee.type";
import { formatDate } from "src/utils";

interface DisplayTableRowProps {
  trainee: Trainee;
  editTrainee: (trainee:Trainee) => void;
  copyAddress: (trainee: Trainee) => void;
}

const DisplayTableRow = ({trainee, editTrainee, copyAddress}: DisplayTableRowProps) => {
  return (
    <tr className="hover:bg-base-200/60 transition-colors duration-200">
      {/* Name */}
      <td className="py-5">
        <div className="flex flex-col">
          <span className="font-semibold text-sm tracking-wide">
            {trainee.full_name.toUpperCase()}
          </span>

          <span className="text-sm text-base-content/60 break-all">
            {trainee.email}
          </span>
        </div>
      </td>

      {/* Calling */}
      <td>
        <span className="font-medium">{trainee.phone_no}</span>
      </td>

      {/* WhatsApp */}
      <td>
        <span className="font-medium">{trainee.whatsapp_no}</span>
      </td>

      {/* Address */}
      <td className="max-w-[320px]">
        <div className="space-y-2">
          <p className="leading-6 whitespace-normal break-words text-sm">
            {trainee.building_name?.toUpperCase()},{" "}
            {trainee.landmark?.toUpperCase()}, {trainee.city?.toUpperCase()}
          </p>

          <div>
            <span className="badge badge-outline badge-sm font-medium">
              PIN : {trainee.pin}
            </span>
          </div>
        </div>
      </td>

      {/* State District */}
      <td>
        <div className="flex flex-col gap-2">
          <span className="font-medium">{trainee.state?.toUpperCase()}</span>

          <span className="badge badge-primary badge-outline badge-sm w-fit text-wrap h-fit text-center">
            {trainee.district?.toUpperCase()}
          </span>
        </div>
      </td>

      {/* Training */}
      <td>
        <span className="badge badge-success badge-outline whitespace-nowrap text-wrap h-fit text-center">
          {trainee.training_program.toUpperCase()}
        </span>
      </td>

      {/* Transaction */}
      <td>
        <span className="font-mono text-sm break-all">
          {trainee.transaction_id}
        </span>
      </td>

      {/* Actions */}
      <td>
        <div className="flex flex-col gap-2">
          <button
            className="btn btn-primary btn-sm"
            onClick={() => editTrainee(trainee)}
          >
            Edit
          </button>

          <button
            className="btn btn-outline btn-sm text-sx"
            onClick={() => copyAddress(trainee)}
          >
            Copy
          </button>
        </div>
      </td>
    </tr>
  );
};

export default DisplayTableRow;